import React from "react";
import { StoreForm } from "./StoreForm";


const SAPStore = () => {
 
  return (
    <>
    
      <StoreForm />
    </>
  );
};

export default SAPStore;
